/* MYSTIC WATCH / Ferox-inspired independent cart v4 */
(function () {
  'use strict';
  if (window.__mysticFeroxCartV4) return;
  window.__mysticFeroxCartV4 = true;

  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const route = (part) => shopRoot.replace(/\/?$/, '/') + part;
  const formatMoney = (cents) => new Intl.NumberFormat('hu-HU', {maximumFractionDigits:0}).format(Math.round((Number(cents)||0)/100)) + ' Ft';
  const escapeHTML = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeURL = (s) => {
    const v=String(s||'');
    if(v.startsWith('//')) return 'https:'+v;
    return v.startsWith('/') || /^https:\/\//i.test(v) ? v : '';
  };
  let root, panel, list, subtotal, count, buttonTotal, savings, shipping, alertBox, rail;
  let currentCart = null;
  let pending = false;
  let pendingForm = null;
  let isOpen = false;
  let lastFocused = null;
  let refreshSerial = 0;
  let refreshTimer = null;

  function setError(message) {
    if (!alertBox) return;
    alertBox.textContent = message || '';
    alertBox.hidden = !message;
  }

  function showCart() {
    if (!root) return;
    lastFocused = document.activeElement;
    root.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('mfc-body-open');
    isOpen = true;
    const close = root.querySelector('[data-mfc-close]');
    if (close) close.focus({preventScroll:true});
  }
  function hideCart() {
    if (!root) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.classList.remove('mfc-body-open');
    isOpen = false;
    setError('');
    if(lastFocused && document.contains(lastFocused) && typeof lastFocused.focus === 'function') lastFocused.focus({preventScroll:true});
  }

  async function requestJSON(url, options) {
    const response = await fetch(url, Object.assign({credentials:'same-origin',headers:{Accept:'application/json'}}, options||{}));
    let json = null;
    try {json = await response.json();} catch (_) {}
    if(!response.ok) throw new Error((json && (json.description || json.message)) || 'Nem sikerült frissíteni a kosarat.');
    return json;
  }
  async function refresh() {
    const serial=++refreshSerial;
    const cart=await requestJSON(route('cart.js'));
    if(serial !== refreshSerial) return;
    currentCart=cart;
    render(cart);
  }
  function refreshSoon() {
    window.clearTimeout(refreshTimer);
    refreshTimer=window.setTimeout(()=>refresh().catch(e=>setError(e.message)),120);
  }
  function updateHeaderCount(quantity) {
    document.querySelectorAll('.cart-link__bubble').forEach(el => el.classList.toggle('cart-link__bubble--visible', quantity>0));
    document.querySelectorAll('[data-mfc-count]').forEach(el => {el.textContent=String(quantity);});
  }

  function itemHTML(item) {
    const qty=Number(item.quantity)||1;
    const key=escapeHTML(item.key);
    const url=safeURL(item.url)||'#';
    const image=safeURL((item.featured_image && item.featured_image.url) || item.image);
    const title=escapeHTML(item.product_title||item.title);
    const options=(item.options_with_values||[]).filter(x=>x.value && x.value!=='Default Title').map(x=>escapeHTML(x.value)).join(' · ');
    const props=Object.entries(item.properties||{}).filter(([k,v])=>k && k[0]!=='_' && v!==null && v!=='' && typeof v!=='object').map(([k,v])=>escapeHTML(k)+': '+escapeHTML(v)).join(' · ');
    const discount=Number(item.original_line_price)>Number(item.final_line_price);
    const old=discount?'<s>'+formatMoney(item.original_line_price)+'</s>':'';
    const imageMarkup=image?'<img src="'+escapeHTML(image)+'" alt="'+title+'" loading="lazy" width="124" height="124">':'<span class="mfc-no-image">MYSTIC</span>';
    return '<article class="mfc-item" data-mfc-key="'+key+'">'+
      '<a class="mfc-item__image" href="'+escapeHTML(url)+'">'+imageMarkup+'</a>'+
      '<div class="mfc-item__details">'+
        '<a class="mfc-item__title" href="'+escapeHTML(url)+'">'+title+'</a>'+
        (options?'<div class="mfc-item__variant">'+options+'</div>':'')+
        (props?'<div class="mfc-item__variant">'+props+'</div>':'')+
        '<div class="mfc-item__bottom"><div class="mfc-quantity" aria-label="Mennyiség">'+
        '<button type="button" data-mfc-qty="-1" data-mfc-key="'+key+'" aria-label="Mennyiség csökkentése">−</button>'+
        '<span>'+qty+'</span>'+
        '<button type="button" data-mfc-qty="1" data-mfc-key="'+key+'" aria-label="Mennyiség növelése">+</button>'+
        '</div><div class="mfc-item__price">'+old+'<strong>'+formatMoney(item.final_line_price)+'</strong></div></div>'+
      '</div><button type="button" class="mfc-remove" data-mfc-remove data-mfc-key="'+key+'" aria-label="Termék eltávolítása">×</button></article>';
  }
  function render(cart) {
    const items=cart.items||[];
    const total=Number(cart.total_price)||0;
    const saved=items.reduce((sum,i)=>sum+Math.max(0,Number(i.original_line_price)-Number(i.final_line_price)),0);
    count.textContent='('+Number(cart.item_count||0)+')';
    subtotal.textContent=formatMoney(total);
    buttonTotal.textContent=formatMoney(total);
    savings.textContent='−'+formatMoney(saved);
    savings.closest('.mfc-savings').hidden=saved<=0;
    list.innerHTML=items.length?items.map(itemHTML).join(''):'<div class="mfc-empty"><strong>A kosarad még üres.</strong><p>Válassz egy MYSTIC órát, és itt megjelenik.</p></div>';
    panel.classList.toggle('mfc-is-empty',items.length===0);
    updateHeaderCount(Number(cart.item_count)||0);
    const checkout=root.querySelector('[data-mfc-checkout]');
    if(checkout) checkout.setAttribute('aria-disabled',String(!items.length || pending));
    root.querySelectorAll('[data-mfc-requires-blaze]').forEach(card=>{card.hidden=!items.some(i=>String(i.handle||'')==='mystic-blaze-okosora');});
    root.querySelectorAll('[data-mfc-upsell]').forEach(btn=>{
      const id=Number(btn.dataset.mfcUpsell);
      const inCart=items.some(item=>Number(item.variant_id)===id);
      const once=btn.hasAttribute('data-mfc-once');
      btn.disabled=pending || (once && inCart);
      btn.textContent=(once && inCart)?'✓ KOSÁRBAN':'+ KOSÁRBA';
    });
    if(shipping) shipping.textContent=items.length?'INGYENES SZÁLLÍTÁS A RENDELÉSEDHEZ':'INGYENES SZÁLLÍTÁS';
  }
  function setBusy(value) {
    pending=value;
    panel.classList.toggle('mfc-is-busy',value);
    root.querySelectorAll('[data-mfc-qty],[data-mfc-remove],[data-mfc-upsell]').forEach(btn=>{btn.disabled=value;});
    const checkout=root.querySelector('[data-mfc-checkout]');
    if(checkout) checkout.setAttribute('aria-disabled',String(value || !currentCart || !currentCart.item_count));
  }
  async function changeQuantity(key, quantity) {
    if(pending) return;
    setError('');setBusy(true);
    try {
      await requestJSON(route('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})});
      await refresh();
    } catch(e) {setError(e.message);} finally {setBusy(false);if(currentCart)render(currentCart);}
  }
  async function addUpsell(id) {
    if(pending)return;
    setError('');setBusy(true);
    try {
      await requestJSON(route('cart/add.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:Number(id),quantity:1})});
      await refresh();
    } catch(e) {setError(e.message);} finally {setBusy(false);if(currentCart)render(currentCart);}
  }
  async function addFromForm(form) {
    if(pendingForm || pending)return;
    pendingForm=form;
    const submit=form.querySelector('[data-mystic-cart-page-trigger]');
    const text=submit && submit.querySelector('[data-add-to-cart-text]');
    const original=text && text.textContent;
    if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}
    if(text)text.textContent='KOSÁR BETÖLTÉSE…';
    try {
      await requestJSON(route('cart/add.js'),{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)});
      setError('');
      showCart();
      await refresh();
    }catch(e){
      setError(e.message);
      showCart();
    }finally{
      pendingForm=null;
      if(submit){submit.disabled=false;submit.removeAttribute('aria-busy');}
      if(text)text.textContent=original;
    }
  }
  function setup() {
    root=document.getElementById('MysticFeroxCartRoot');
    if(!root)return;
    // Escape sticky/transformed header; the drawer lives at viewport level.
    document.body.appendChild(root);
    panel=root.querySelector('.mfc-panel');
    list=root.querySelector('[data-mfc-items]');
    subtotal=root.querySelector('[data-mfc-subtotal]');
    count=root.querySelector('[data-mfc-cart-count]');
    buttonTotal=root.querySelector('[data-mfc-button-total]');
    savings=root.querySelector('[data-mfc-savings]');
    shipping=root.querySelector('[data-mfc-shipping]');
    alertBox=root.querySelector('[data-mfc-error]');
    rail=root.querySelector('.mfc-upsell-rail');

    // Capture before Motion's delegated/element handlers. No native drawer toggle.
    document.addEventListener('click',function(event){
      const trigger=event.target.closest('.mystic-cart-trigger, .js-drawer-open-cart, [data-mfc-open]');
      if(trigger){
        event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
        setError('');showCart();refresh().catch(e=>setError(e.message));
        return;
      }
    },true);
    document.addEventListener('submit',function(event){
      const form=event.target;
      if(!form || !form.matches('form.product-single__form') || !form.querySelector('[data-mystic-cart-page-trigger]'))return;
      event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
      addFromForm(form);
    },true);

    document.addEventListener('click',function(event){
      const buy=event.target.closest('[data-mystic-cart-page-trigger]');
      if(!buy)return;
      const form=buy.closest('form.product-single__form');
      if(!form)return;
      event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
      addFromForm(form);
    },true);
    root.addEventListener('click',function(event){
      const checkoutLink=event.target.closest('[data-mfc-checkout]');
      if(checkoutLink && checkoutLink.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}
      if(event.target.closest('[data-mfc-close]') || event.target.closest('.mfc-backdrop')){hideCart();return;}
      const change=event.target.closest('[data-mfc-qty],[data-mfc-remove]');
      if(change && currentCart){
        const key=change.dataset.mfcKey;
        const item=currentCart.items.find(i=>i.key===key);
        if(item)changeQuantity(key,change.hasAttribute('data-mfc-remove')?0:Number(item.quantity)+Number(change.dataset.mfcQty));
        return;
      }
      const upsell=event.target.closest('[data-mfc-upsell]');
      if(upsell){addUpsell(upsell.dataset.mfcUpsell);return;}
      const arrow=event.target.closest('[data-mfc-prev],[data-mfc-next]');
      if(arrow && rail){
        const card=rail.querySelector('.mfc-upsell');
        const amount=card?card.getBoundingClientRect().width+10:rail.clientWidth*.85;
        rail.scrollBy({left:arrow.hasAttribute('data-mfc-prev')?-amount:amount,behavior:'smooth'});
      }
    });
    document.addEventListener('keydown',function(event){
      if(!isOpen)return;
      if(event.key==='Escape'){event.preventDefault();hideCart();}
      if(event.key==='Tab'){
        const focusable=Array.from(panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')).filter(el=>el.getClientRects().length>0);
        if(!focusable.length)return;
        const first=focusable[0],last=focusable[focusable.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
    ['cart:updated','cart:build','cart:added'].forEach(name=>document.addEventListener(name,function(){if(isOpen)refreshSoon();}));
    refresh().catch(()=>{});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
})();